import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
// import PC from './components/Layout.vue';
// import Mobile from './components/mobile/index.vue';
import App from './App.vue';
import 'animate.css';
import './assets/font_v5umkzvj2o/iconfont.css';
import '../src/assets/reset.css';
import '../src/assets/mobile.css';
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
import {getDeviceType} from '../src/utils/index'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(ElementUI);
Vue.use(MintUI)
Vue.prototype.$wow = wow
let deviceType = getDeviceType()

if(deviceType == 'PC'){
  router.afterEach((to,form)=>{
    console.log(to,form)
    document.documentElement.scrollTop = 100;
  }) 
}else{
  
  // function adaptive() {
  //   // 在标准 375px 适配下，1rem = 16px;
  //   var baseFontSize = 16
  //   var baseWidth = 375
  //   var set = function() {
  //       var clientWidth = document.documentElement.clientWidth || window.innerWidth
  //       console.log('clientWidth',clientWidth)
  //       var fz = 16
  //       if (clientWidth != baseWidth) {
  //         console.log()
  //           fz = Math.floor(clientWidth / baseWidth * baseFontSize)
  //       }
  //       document.querySelector('html').style.fontSize = fz + 'px'
  //   }
  //   set()
  //   // 监听窗口重置事件
  //   window.addEventListener('resize', set)
  // }
  // adaptive()
  router.afterEach((to,form)=>{
    console.log(to,form)
    window.scrollTo(0,0);
  }) 
  fnResize()
  window.onresize = function () {
      fnResize()
  }

  function fnResize() {
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth
      if (deviceWidth >= 750) {
          deviceWidth = 750
      }
      if (deviceWidth <= 320) {
          deviceWidth = 320
      }
      // 375 16 
      document.documentElement.style.fontSize = (deviceWidth / 23.43) + 'px'
  }
}

new Vue({
  el: '#app',
  router,
  // render: h => h(deviceType=='PC'?PC:Mobile)
  render: h => h(App)
});
